export const environment = {
  production: false,
  apiUrl: 'https://apidev.aicub.ru/v1',
  chatUrl: 'https://chatdev.aicub.ru/v1',
  imgUrlStorage: 'https://apidev.aicub.ru/storage/',
  wsUrl: 'wss://wsdev.aicub.ru/ws',
};
